import './import/rodu-roosa.gif';
import './import/kalamaja-roosa.gif';
import './import/kvartal-roosa.gif';
import './import/korterihang-roosa.gif';
import './import/loftid-roosa.gif';
import './import/telliskivi-roosa.gif';
import './import/vanalinn-roosa.gif';
import './import/jalutavad-roosa.gif';
import './import/terrass-roosa.gif';

import './import/rodu-roh.gif';
import './import/kalamaja-roh.gif';
import './import/kvartal-roh.gif';
import './import/korterihang-roh.gif';
import './import/loftid-roh.gif';
import './import/telliskivi-roh.gif';
import './import/vanalinn-roh.gif';
import './import/jalutavad-roh.gif';
import './import/terrass-roh.gif';

import './import/rodu-sinine.png';

import Component from '../component/component';

import './navigation.scss';

const animationSpeed: number = 300;
const isSmallScreen: () => boolean = () => window.matchMedia('(max-width: 999px)').matches;

interface INavigationSettings {
    elementClass?: string;
    toggleClass?: string;
    animationItemClass?: string;
    childClass?: string;
    visibleClass?: string;
    opaqueClass?: string;
}

export default class Navigation extends Component {
    static initSelector: string = '.js-navigation';

    items: NavigationItem[];
    containers: JQuery;
    settings: INavigationSettings;
    animationHideTimeout: number;
    animationShowTimeout: number;
    links: JQuery;

    constructor(target: HTMLElement) {
        super(target);

        this.items = this.element.find('.navigation__item.has-children')
            .map((index: number, element: HTMLElement) => NavigationItem.create<typeof NavigationItem>(element))
            .toArray();
        this.containers = this.element.find('.navigation__animation-item');
        this.settings = {
            animationItemClass: 'navigation__animation-item',
            childClass: 'navigation__item.has-children',
            elementClass: 'navigation__link',
            opaqueClass: 'is-opaque',
            toggleClass: 'is-open',
            visibleClass: 'is-visible',
        };
        this.links = this.element.find('.' + this.settings.elementClass);

        this.init();
    }

    init(): void {
        this.links.on('mouseover', this.hover.bind(this));
    }

    public closeItems(): void {
        for (const item of this.items) {
            item.close(false);
        }
    }

    hover(event: JQuery.TriggeredEvent): void {
        if ($(window).innerWidth() > 767) {
            // eslint-disable-next-line  @typescript-eslint/no-this-alias
            const self: Navigation = this;
            const name: string = $(event.target).parent().data('name');
            const target: JQuery = this.containers.filter('[data-target="' + name + '"]');
            const img: JQuery = target.find('.navigation__image .image__img');
            const visible: JQuery = this.containers.filter('.' + this.settings.opaqueClass + ', .' + this.settings.visibleClass);

            if (visible.length) {
                visible.not(target).removeClass(this.settings.opaqueClass);
                if (visible.data('target') !== name) {
                    clearTimeout(this.animationHideTimeout);
                    this.animationHideTimeout = window.setTimeout(() => {
                        self.containers.removeClass(self.settings.visibleClass);

                        self.showAnimation(target, img);
                    }, 100);
                }
            } else {
                this.showAnimation(target, img);
            }
        }
    }

    public showAnimation(target: JQuery, img: JQuery): void {
        target.addClass(this.settings.visibleClass);
        this.fadeImageIn(target, img);
    }

    fadeImageIn(target: JQuery, img: JQuery): void {
        img.attr('src', '');
        clearTimeout(this.animationShowTimeout);
        this.animationShowTimeout = window.setTimeout(() => {
            img.attr('src', img.attr('data-src'));
            target.addClass('is-opaque');
        }, 20);
    }
}

class NavigationItem extends Component {
    static initSelector: string = '.js-navigation-item';

    public isOpen: boolean = false;
    public link: JQuery;
    public list: JQuery;

    constructor(target: HTMLElement) {
        super(target);

        this.link = this.element.children('.navigation__link');
        this.list = this.element.children('.navigation__list');
        this.handleOutsideClick = this.handleOutsideClick.bind(this);

        this.element.on('keyup.navigationItem', this.handleKeyup.bind(this));
        this.link.on('click', this.toggle.bind(this));
    }

    open(): void {
        this.isOpen = true;
        // on small screens, open with slide animation
        if (isSmallScreen()) {
            this.openWithAnimation();
        } else {
            this.finishOpen();
        }

        $(document).on('click.navigationItem', this.handleOutsideClick);
    }

    finishOpen(): void {
        this.element.addClass('is-open');
        this.element.children('.navigation__link').attr('aria-expanded', 'true');
    }

    openWithAnimation(): void {
        const dropdownHeight: number = this.list[0].scrollHeight;

        this.list.stop().animate({
            height: dropdownHeight,
        }, animationSpeed, (): void => {
            this.list.removeAttr('style');
            this.finishOpen();
        });
    }

    close(shouldFocusAfterClose: boolean): void {
        this.isOpen = false;

        // on small screens, close with slide animation
        if (isSmallScreen()) {
            this.closeWithAnimation(shouldFocusAfterClose);
        } else {
            this.finishClose(shouldFocusAfterClose);
        }

        $(document).off('click.navigationItem', this.handleOutsideClick);
    }

    finishClose(shouldFocus: boolean): void {
        this.element.removeClass('is-open');
        this.element.children('.navigation__link').attr('aria-expanded', 'false');
        if (shouldFocus) {
            this.element.children('.navigation__link').focus();
        }
    }

    closeWithAnimation(shouldFocusAfterClose: boolean): void {
        this.list.stop().animate({
            height: 0,
        }, animationSpeed, (): void => {
            this.list.removeAttr('style');
            this.finishClose(shouldFocusAfterClose);
        });
    }

    toggle(event: JQuery.ClickEvent): void {
        event.preventDefault();

        if (this.isOpen) {
            this.close(false);
        } else {
            this.open();
        }
    }

    handleOutsideClick(event: JQuery.TriggeredEvent): void {
        if (!isSmallScreen()) {
            if ($(event.target).closest(this.element).length === 0) {
                this.close(false);
            }
        }
    }

    handleKeyup(event: KeyboardEvent): void {
        if (event.key === 'Escape') {
            this.close(true);
        }
    }

    destroy(): void {
        $(document).off('click.navigationItem', this.handleOutsideClick);
    }
}
